export const capitalize = (string: string | undefined) =>
    string && string.length > 0 ? string[0].toUpperCase() + string.substring(1) : ''

export const renderS = (list: any[]) => (list.length > 1 ? 's' : '')

export const toCurrency = (value: number | undefined) => {
    if (value === undefined) return ''
    return `$${value.toLocaleString('en-AU', { currency: 'AUD', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export const willTextOverflow = (text: string, maxCharsPerLine: number, maxLines: number) => {
    const words = text.split(/\s+/)
    let lineCount = 0
    let currentLine = ''

    for (const word of words) {
        if ((currentLine + ' ' + word).trim().length <= maxCharsPerLine) {
            currentLine = (currentLine + ' ' + word).trim()
        } else {
            lineCount++
            currentLine = word
        }
    }

    if (currentLine) lineCount++ // count the last line

    return {
        lineCount,
        willOverflow: lineCount > maxLines,
    }
}

export const getUserFullName = (user: { firstName: string; lastName: string }) =>
    `${user.firstName} ${user.lastName}`
